module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"energy":"Energie","energyDemand":{"ee":"Endenergie","pe":"Primärenergie (PE)","penr":"PE Nicht erneuerbar","per":"PE Erneuerbar"},"energyUsage":"Verwendungszweck","energyCarrier":"Energieträger","measurementData":"Messdaten","reductionPaths":"Absenkpfade"}}')
  delete Component.options._Ctor
}
